import React from 'react';

export default function CoachWhistle(props) {
    return (
        <svg
            className={props.className}
            width="48px"
            height="48px"
            viewBox="0 0 42 48"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>TrainHeroic</title>
            <desc>Created with Sketch.</desc>
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Desktop-/-Pricing-/-08-.b"
                    transform="translate(-531.000000, -256.000000)"
                >
                    <g
                        id="Icon-/-Coach-/-Gray"
                        transform="translate(527.000000, 256.000000)"
                    >
                        <g
                            id="baseline-chat_bubble_outline-24px"
                            strokeWidth="1"
                            fillRule="evenodd"
                        >
                            <polygon
                                id="Path"
                                points="0 0 48 0 48 48 0 48"
                            ></polygon>
                        </g>
                        <path
                            d="M41.5848919,8.52752853 L45.7038244,15.5809689 C46.0756419,16.2176856 45.9841599,17.0293955 45.4803945,17.5634371 C42.0495771,21.2004464 39.1442928,24.1671338 36.7619506,26.4656168 C36.1508089,27.0552462 35.8640751,27.4934037 35.751485,27.8993673 C35.6415828,28.295639 35.6488679,28.5961142 35.7850345,29.9630992 C35.9198033,31.3160519 35.9539505,32.2557203 35.8552975,33.4793708 C35.725225,35.0927349 35.355077,36.8379084 34.6826513,38.8249697 C33.0928743,43.5228631 28.8662251,46.8587742 23.7543151,47.7597812 C18.524304,48.6816043 13.1678624,46.9377869 9.42919984,42.7450623 C5.7474,38.6161065 4.42002259,33.4246417 5.43121764,28.4426707 C6.37525461,23.791575 9.28954011,19.8656783 13.1369097,18.191539 C17.6467091,16.2291508 26.4740119,12.7772451 39.6415161,7.82587798 C40.3704312,7.55178456 41.1873282,7.846723 41.5848919,8.52752853 Z M20.5517241,24.2758621 C16.2858006,24.2758621 12.8275862,27.7340764 12.8275862,32 C12.8275862,36.2659236 16.2858006,39.7241379 20.5517241,39.7241379 C24.8176477,39.7241379 28.2758621,36.2659236 28.2758621,32 C28.2758621,27.7340764 24.8176477,24.2758621 20.5517241,24.2758621 Z M6.6080858,8.03726135 L12.6978137,12.4572946 C13.4340336,12.9916562 13.5995761,14.0243007 13.0675632,14.7637707 C12.5355503,15.5032407 11.5074444,15.669514 10.7712245,15.1351524 L4.68149661,10.7151192 C3.94527673,10.1807576 3.77973426,9.1481131 4.31174718,8.40864309 C4.84376009,7.66917308 5.87186591,7.50289981 6.6080858,8.03726135 Z M13.7002065,0.870124227 L18.7007443,10.2528453 C19.1292372,11.0568448 18.8310591,12.0593297 18.0347447,12.491958 C17.2384304,12.9245863 16.2455279,12.6235305 15.8170349,11.8195309 L10.8164971,2.43680992 C10.3880042,1.63281041 10.6861823,0.63032549 11.4824967,0.197697183 C12.278811,-0.234931124 13.2717135,0.0661247177 13.7002065,0.870124227 Z M23.3103448,1.10344828 C24.2244713,1.10344828 24.9655172,1.80649185 24.9655172,2.67374005 L24.9655172,9.46419098 C24.9655172,10.3314392 24.2244713,11.0344828 23.3103448,11.0344828 C22.3962183,11.0344828 21.6551724,10.3314392 21.6551724,9.46419098 L21.6551724,2.67374005 C21.6551724,1.80649185 22.3962183,1.10344828 23.3103448,1.10344828 Z"
                            id="Combined-Shape"
                            fill="#4A4A4A"
                            fillRule="nonzero"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
